module.exports = __webpack_public_path__ + "static/img/lianxi.888d227c.jpg";